/**
 * API URL utility with fallback for production deployment.
 * Ensures the path ends with /api/v1 so host-only env vars (e.g. http://localhost:8000) still work.
 */
const normalizeApiBase = (raw: string): string => {
  const base = raw.replace(/\/+$/, '');
  if (/\/api\/v1$/i.test(base)) return base;
  return `${base}/api/v1`;
};

const upgradeHttpToHttpsWhenPageIsSecure = (url: string): string => {
  if (!url.startsWith('http://')) return url;
  if (typeof window === 'undefined') return url;
  if (window.location.protocol !== 'https:') return url;

  try {
    const parsed = new URL(url);
    if (parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1') {
      return url;
    }
    parsed.protocol = 'https:';
    return parsed.href.replace(/\/+$/, '');
  } catch {
    return url.replace(/^http:\/\//i, 'https://');
  }
};

export const getApiUrl = (): string => {
  const sameOriginApi = () =>
    typeof window !== 'undefined'
      ? `${window.location.origin.replace(/\/+$/, '')}/api/v1`
      : '/api/v1';

  // On HTTPS custom domains, same-origin avoids certificate mismatch errors
  // when the ALB hostname cert does not match the browser host.
  if (
    typeof window !== 'undefined' &&
    window.location.protocol === 'https:' &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
  ) {
    const raw = (process.env.REACT_APP_API_URL || '').trim();
    if (!raw || /elderly-wellness-alb-1007580489\.us-east-1\.elb\.amazonaws\.com/i.test(raw)) {
      return sameOriginApi();
    }
  }

  const fallback =
    'https://elderly-wellness-alb-1007580489.us-east-1.elb.amazonaws.com/api/v1';
  const raw = (process.env.REACT_APP_API_URL || '').trim();
  const base = raw ? normalizeApiBase(raw) : fallback;
  return upgradeHttpToHttpsWhenPageIsSecure(base);
};

